import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
  Box,
} from "@mui/material";

export default function ImageDialog({ src, ...dialogProps }) {
  const [loading, setLoading] = useState(true);

  return (
    <Dialog maxWidth="md" {...dialogProps}>
      <DialogContent
        sx={{
          height: "fit-content",
          maxHeight: "90vh",
          minWidth: "40vw",
          p: 0,
          m: 0,
        }}
      >
        <Button
          sx={{
            position: "absolute",
            top: "1rem",
            left: "1rem",
            zIndex: 2,
          }}
          variant="contained"
          onClick={dialogProps.onClose}
          startIcon={<Close />}
        >
          Close
        </Button>

        {loading && (
          <Box
            sx={{
              height: "20rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}

        <img
          src={src}
          onLoad={() => setLoading(false)}
          style={{
            width: "100%",
            height: "auto",
            display: loading ? "none" : "block",
          }}
          alt="Content"
        />
      </DialogContent>
    </Dialog>
  );
}
